import img from "../../img/Logo.svg";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { motion } from "framer-motion";
import { useHistory, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";

import { ContainerLogin, FormButton1, FormButton2, FormLogin } from "./styles";
import { api } from "../../services/api";

export const Login = ({ setUser, login, setLogin }) => {
  const history = useHistory();

  const schema = yup.object().shape({
    email: yup.string().required("Email obrigatório!").email("Email inválido!"),
    password: yup
      .string()
      .required("Senha obrigatória!")
      .min(8, "Mínimo de 8 characters!")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
        "Obrigatório: letra maiúscula, número e character especial!"
      ),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const signin = () => {
    history.push("/register");
  };

  const LoginSubmit = ({ email, password }) => {
    const user = { email, password };
    api
      .post("/sessions", user)
      .then((res) => {
        localStorage.setItem("@Kenzie_Hub_USER_TOKEN", res.data.token);
        toast.success("Login realizado com sucesso!");
        return history.push(`/dashboard/${res.data.user.id}`);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Email ou senha inválidos.");
        setLogin(false);
        setUser(null);
      });

    if (login) {
      return <Redirect to="/dashboard/:id" />;
    }
  };
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <ContainerLogin>
        <figure>
          <img src={img} alt="logo" />
        </figure>

        <FormLogin onSubmit={handleSubmit(LoginSubmit)}>
          <h1>Login</h1>
          <div>
            <label>Email</label>
            <input
              type="email"
              placeholder="Digite aqui seu email"
              {...register("email")}
            />
            {errors.email && <span>{errors.email.message}</span>}
          </div>

          <div>
            <label>Senha</label>
            <input
              type="password"
              placeholder="Digite aqui sua senha"
              {...register("password")}
            />
            {errors.password && <span>{errors.password.message}</span>}
          </div>

          <FormButton1 type="submit">Entrar</FormButton1>
          <p>Ainda não possui uma conta?</p>
          <FormButton2 onClick={() => signin()}>Cadastre-se</FormButton2>
        </FormLogin>
      </ContainerLogin>
    </motion.div>
  );
};
